import { render, staticRenderFns } from "./4mImprRiskReduce.vue?vue&type=template&id=0ec19f33"
import script from "./4mImprRiskReduce.vue?vue&type=script&lang=js"
export * from "./4mImprRiskReduce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ec19f33')) {
      api.createRecord('0ec19f33', component.options)
    } else {
      api.reload('0ec19f33', component.options)
    }
    module.hot.accept("./4mImprRiskReduce.vue?vue&type=template&id=0ec19f33", function () {
      api.rerender('0ec19f33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/4m/risk/4mImprRiskReduce.vue"
export default component.exports